// prettier-ignore
import { type ProctorSpecification } from '../../../shared/proctor/ProctorSpecification';

export const RnInterviewPromptMigrationTst = {
    name: 'rn_interview_prompt_migration_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Test: 1,
    },
} satisfies ProctorSpecification;

export type RnInterviewPromptMigrationTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isTest: boolean;
};

export const TareCodegenTst = {
    name: 'tare_codegen_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        ControlAa: 1,
        Active: 2,
    },
} satisfies ProctorSpecification;

export type TareCodegenTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isControlAa: boolean;
    isActive: boolean;
};

export type SharedProctorSpecification =
    | typeof RnInterviewPromptMigrationTst
    | typeof TareCodegenTst;

export type SharedProctorAllocation =
    | RnInterviewPromptMigrationTstAllocation
    | TareCodegenTstAllocation;

export const SharedProctorSpecifications = [
    RnInterviewPromptMigrationTst,
    TareCodegenTst,
];